import { render, staticRenderFns } from "./BoxShadow.vue?vue&type=template&id=7b900504&scoped=true&"
import script from "./BoxShadow.vue?vue&type=script&lang=js&"
export * from "./BoxShadow.vue?vue&type=script&lang=js&"
import style0 from "./BoxShadow.vue?vue&type=style&index=0&id=7b900504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b900504",
  null
  
)

export default component.exports